import { render, staticRenderFns } from "./ServiceCardCover.vue?vue&type=template&id=ca3ae69a&scoped=true&"
import script from "./ServiceCardCover.vue?vue&type=script&lang=js&"
export * from "./ServiceCardCover.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCardCover.vue?vue&type=style&index=0&id=ca3ae69a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3ae69a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
